/** @file Pushes a named key context (e.g. `viewport`) while a panel or tool has focus; returns the pop. */
import { keyState } from './_internal/keyState';

/** Bindings of the most recently pushed context win over older ones and over `global`. The disposer is idempotent. */
export function pushContext(context: string): () => void {
  const entry = { name: context };
  keyState.contexts.push(entry);
  return () => {
    const i = keyState.contexts.indexOf(entry);
    if (i >= 0) keyState.contexts.splice(i, 1);
  };
}
